/*
 * Module to handle substitution group entries of a single substitution group
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/substitutions/substitutionGroup/substitutionGroupEntries/substitutionGroupEntriesView",
], function (Marionette, Messenger, SubstitutionGroupEntriesView) {
  var SubstitutionGroupEntriesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "substitutionGroupEntries";
      this.region = options.region;
      this.pendingNewEntry = false; //true if there is a blank new entry in the collection
    },
    show: function (entries) {
      this.substitutionGroupEntries = entries;
      this._setUpView();
      this.showRegion(this.view, { loading: true });
    },
    emptyError: function (errorMessage) {
      this.view.emptyError(errorMessage);
    },
    _setUpView: function () {
      this.view = new SubstitutionGroupEntriesView.substitutionGroupEntriesView({
        collection: this.substitutionGroupEntries,
      });

      //handle toggling auto-apply
      this.view.on(
        "itemview:toggle:default:entry",
        function (view) {
          //toggle whether entry is auto applied
          view.model.set("defaultEntry", !view.model.get("defaultEntry"));
        },
        this,
      );

      //handle removing an entry
      this.view.on(
        "itemview:delete:entry",
        function (deleteView) {
          Messenger.yesNoDialog(
            "substitutions.entries.dialog.delete",
            {
              yes: () => {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Substitution",
                  id: deleteView.model.id,
                  idType: "Substitution",
                  object: "Substitution",
                });
                deleteView.model.deleteModel();
                //if we delete a pending entry, then reset pending entry boolean to false (since there isn't a pending entry anymore)
                if (this.pendingNewEntry && this.newEntry === deleteView.model) {
                  console.log("delete new entry");
                  Messenger.vent.trigger("cancel:textbox");
                }
              },
            },
            this,
          );
        },
        this,
      );

      //handle adding a new entry
      this.view.on(
        "add:entry",
        function () {
          //only add a new entry if there isn't an existing new entry open and we can close the current textbox
          if (!this.pendingNewEntry && Messenger.reqres.request("save:textbox")) {
            this.pendingNewEntry = true; //created new blank entry
            console.log("add entry");
            this.newEntry = this.substitutionGroupEntries.addNewEntry();
            //if we cancel out the field for the new entry, remove it from the collection
            this.newEntry.once(
              "cancel",
              function () {
                if (this.pendingNewEntry) {
                  //only remove entry if it still pending (enter has not been clicked)
                  console.log("cancel entry");
                  this.substitutionGroupEntries.remove(this.newEntry);
                  this.pendingNewEntry = false; //new entry is gone, so we can add another new one
                }
              },
              this,
            );
            //if the new entry gets data written to it, it's no longer pending
            this.newEntry.once(
              "enter",
              function () {
                console.log("filled out");
                this.pendingNewEntry = false; //new entry is properly filled out, so we can add another blank one
              },
              this,
            );
            //get view for this entry
            var newView = this.view.children.findByModel(this.newEntry);
            newView.enableTextbox("#entryName");
          }
        },
        this,
      );

      //get history
      this.view.on(
        "get:history",
        function () {
          Messenger.vent.trigger("show:history");
        },
        this,
      );
    },
  });

  return SubstitutionGroupEntriesController;
});
